// Раскомментировать если нужны подсказки по ip
// import {ip} from "./currentIp.json";
import type { MFNamesKeys } from '../MFNames';
export type BaseDevConfig = typeof baseDevConfig;
export type DevConfig = BaseDevConfig & {
	useLocal: MFNamesKeys[];
};
enum Browsers {
	'Google Chrome Canary' = 'Google Chrome Canary',
	'Google Chrome Dev' = 'Google Chrome Dev',
	'Google Chrome Beta' = 'Google Chrome Beta',
	'Google Chrome' = 'Google Chrome',
	'Microsoft Edge' = 'Microsoft Edge',
	'Brave Browser' = 'Brave Browser',
	Vivaldi = 'Vivaldi',
	Chromium = 'Chromium',
}
const baseDevConfig = {
	useExternalIP: false,
	browser: Browsers['Google Chrome'],
	serviceWorkerMockApi: false,
	serviceWorkerCacheApi: false,
	serviceWorkerCacheTimeInMinutes: 1440000,
	externalIp: '',
};

export const devConfig: DevConfig = {
	...baseDevConfig,
	useLocal: [],
};
